import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { addQuestion } from '../../actioncreators/actioncreators'

const { Component } = React

const Button = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  min-width: 286px;
  max-width: 286px;
  min-height: 132px;
  max-height: 132px;
  margin-left: 2px;
  margin-bottom: 20px;

  background: #ffffff00;
  border: none;
  outline: none;

  &:focus {
    outline: none;
  }
`

const I = styled.i`
-webkit-transition: -webkit-transform .1s ease-in-out;
transition: transform .1s ease-in-out;
margin-left: -120px;
color: #FF3B26;

&:hover {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
`

class AddQuestionButton extends Component {
  render () {
    return (
      <Button onClick={this.props.addQuestion}>
        <I className='fas fa-plus fa-5x' title='Add question' />
      </Button>)
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    addQuestion: () => dispatch(addQuestion())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddQuestionButton)
